module.exports = __webpack_public_path__ + "static/media/payment-logo-troy.81adc9f3.svg";